module.exports = __webpack_public_path__ + "img/0xe3DB50049C74De2F7d7269823af3178Cf22fd5E3.cb9b3252.png";